import * as React from 'react';
import { Button, Stack, Tab, Tabs } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { IsAllowed, PageTitle } from 'gossamer-front-end';
import { TaskDefinition } from 'gossamer-model';
import { WorkflowSearch } from './WorkflowSearch';
import { ActiveTaskReport } from './ActiveTaskReport';
import { WorkflowUserReport } from './WorkflowUserReport';

export const ManageWorkflow = (): React.JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <>
      <PageTitle title="Manage Workflow" subtitle="Use workflows to organise your tasks and processes" />
      <Stack direction="horizontal" gap={2} className="mb-3">
        <IsAllowed entity={TaskDefinition} action="create">
          <Link to="/admin/workflow/create">
            <Button size="sm" variant="primary">
              Create a new Workflow
            </Button>
          </Link>
        </IsAllowed>
        <Link to="/admin/workflow/initiate">
          <Button size="sm" variant="primary">
            Initiate a Workflow for a User
          </Button>
        </Link>
      </Stack>

      <Tabs
        activeKey={searchParams.get('tab') || 'search'}
        className="mb-3"
        variant="underline"
        mountOnEnter={true}
        unmountOnExit={true}
        onSelect={(tab) => {
          const newParams = new URLSearchParams();
          newParams.set('tab', tab);
          setSearchParams(newParams);
        }}
      >
        <Tab eventKey="search" title="Workflow Search">
          <WorkflowSearch />
        </Tab>
        <Tab eventKey="active-tasks" title="Active Tasks">
          <ActiveTaskReport />
        </Tab>
        <Tab eventKey="workflow-progress" title="Workflow Progress">
          <WorkflowUserReport />
        </Tab>
      </Tabs>
    </>
  );
};
